import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BasketPageCheckoutOrderModel } from "./checkoutOrderView";
import BasketListItems from "./BasketListItems";

interface EshopBasketAppProperties {
    readonly checkoutOrderModel: BasketPageCheckoutOrderModel;
}

export default function EshopBasketApp({ checkoutOrderModel }: EshopBasketAppProperties): React.JSX.Element {
    const queryClient = new QueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <BasketListItems basketPageCheckoutOrderModel={checkoutOrderModel} />
        </QueryClientProvider>
    );
}
